import axios, { AxiosRequestConfig } from "axios"

const RAW_API_URL = process.env.API_URL
if (!RAW_API_URL) {
  throw new Error("Please provide the API_URL environment variable.")
}

// Every generated endpoint path is prefixed with `/api/...`, so the base URL must
// be the bare origin. Some deployment environments set API_URL with a trailing
// `/api` (or trailing slash); left as-is that double-prefixes every request to
// `/api/api/...` → 404 (silently breaks all form submissions). Normalise here so
// the base is always the origin, regardless of how the env var is configured.
const API_URL = RAW_API_URL.replace(/\/+$/, "").replace(/\/api$/i, "")

export function getUploadURL(href: string) {
  return API_URL + href
}

const config: AxiosRequestConfig = {
  baseURL: API_URL,
}

const instance = axios.create(config)

export const setToken = (token: string) =>
  (instance.defaults.headers["Authorization"] = `Bearer ${token}`)

export const setLanguageHeader = (locale: "he" | "en") => {
  instance.defaults.headers["X-Accept-Language"] =
    locale === "he" ? `he-IL` : "en-US"
}

export const clearToken = () =>
  delete instance.defaults.headers["Authorization"]

export default instance

export const CancelToken = axios.CancelToken
